module.exports={
  "name": "inspect",
  "version": "2.52.0",
  "private": true,
  "description": "Inspect is an intuitive and user-friendly method of tracking findings and resolutions",
  "main": "server/server.js",
  "browser": {
    "loki-angular": "./www/lib/lokijs/src/loki-angular.js"
  },
  "scripts": {
    "build": "gulp build",
    "build:client": "gulp build:client",
    "changelog": "gulp changelog",
    "cypress open": "./node_modules/.bin/cypress open",
    "integration": "jest --passWithNoTests --forceExit --testMatch=\"**/*.integration.js\"",
    "lint": "eslint ./server ./client",
    "lint:client": "eslint ./client",
    "lint:server": "eslint ./server",
    "migrate": "migrate-mongo create $@",
    "process:escape-s3-attachment": "node server/job/escape-s3-attachment",
    "process:report-dump": "node cli/report-dump",
    "process:report-emails": "node server/job/report.emails.job.js",
    "process:s3-attachments-thumbnail-delete": "node server/job/s3.attachments.thumbnail.delete.js",
    "process:verification-emails": "node server/job/verification.emails.job.js",
    "spec": "jest",
    "start": "gulp",
    "update:lived-name-party": "node server/job/update-lived-name-party.js",
    "update:lived-name-program": "node server/job/update-lived-name-program.js",
    "update:lived-name-routing": "node server/job/update-lived-name-routing.js"
  },
  "prettier": {
    "arrowParens": "always",
    "printWidth": 120,
    "singleQuote": true,
    "trailingComma": "all"
  },
  "eslintConfig": {
    "env": {
      "jest": true
    },
    "plugins": [
      "prettier"
    ],
    "extends": [
      "airbnb-base",
      "prettier"
    ],
    "rules": {
      "consistent-return": "off",
      "func-names": "off",
      "global-require": "off",
      "no-underscore-dangle": "off",
      "spaced-comment": "off",
      "prettier/prettier": [
        "error"
      ]
    },
    "ignorePatterns": [
      "misc/**",
      "**/scripts",
      "appium/**",
      "assets/**",
      "www/**"
    ]
  },
  "jest": {
    "collectCoverage": true,
    "coveragePathIgnorePatterns": [
      "/misc/",
      "/common/",
      "test.js"
    ],
    "roots": [
      "server/",
      "client/"
    ],
    "setupFiles": [
      "<rootDir>/setup.jest.js"
    ],
    "transform": {
      "^.+\\.js$": "babel-jest"
    },
    "transformIgnorePatterns": [
      "/node_modules/(?!(axios|chai|@babel/runtime|sinon|bson)/)"
    ]
  },
  "resolutions": {
    "@actions/core": "1.10.0",
    "axios": "1.8.2",
    "body-parser": "1.20.3",
    "braces": "3.0.3",
    "cross-spawn": "7.0.6",
    "elliptic": "6.6.1",
    "flat": "5.0.2",
    "follow-redirects": "1.15.6",
    "graceful-fs": "4.2.3",
    "handlebars": "4.7.7",
    "jose": "4.15.5",
    "js-yaml": "^3.13.1",
    "json5": "1.0.2",
    "lodash": "4.17.21",
    "micromatch": "4.0.8",
    "minimatch": "3.0.5",
    "minimist": "1.2.8",
    "moment": "2.29.4",
    "mongodb": "4.17.0",
    "path-to-regexp": "0.1.12",
    "pathval": "1.1.1",
    "postcss": "8.4.24",
    "qs": "6.9.7",
    "semver": "7.5.2",
    "tough-cookie": "5.1.2",
    "underscore": "1.12.1",
    "xml2js": "0.5.0",
    "yargs-parser": "21.1.1"
  },
  "dependencies": {
    "@risk-and-safety/auth-security-middleware": "2.1.0",
    "@rss/common": "0.20.1",
    "@rss/common-nodejs": "1.7.8",
    "advanced-date-parser": "0.0.8",
    "agenda": "5.0.0",
    "agentkeepalive": "4.1.4",
    "angular-moment": "1.3.0",
    "angularjs-dragula": "2.0.0",
    "app-root-dir": "1.0.2",
    "axios": "1.8.2",
    "body-parser": "1.20.3",
    "bson": "4.4.0",
    "com-badrit-base64": "^0.2.0",
    "compression": "1.7.4",
    "cors": "^2.8.5",
    "express": "4.19.2",
    "express-jwt-authz": "^2.4.1",
    "express-query-boolean": "2.0.0",
    "filehound": "1.17.4",
    "hbs": "4.1.2",
    "helmet": "4.6.0",
    "jest-github-actions-reporter": "^1.0.3",
    "jest-sonar-reporter": "^2.0.0",
    "jsonwebtoken": "9.0.0",
    "kafkajs": "1.15.0",
    "lodash": "4.17.21",
    "memory-cache": "0.2.0",
    "migrate-mongo": "8.2.2",
    "mime-types": "2.1.31",
    "moment": "2.29.4",
    "moment-timezone": "0.5.35",
    "multer": "1.4.5-lts.1",
    "ng-idle": "^1.3.2",
    "ng-infinite-scroll": "^1.3.0",
    "nocache": "3.0.4",
    "node-html-parser": "3.3.6",
    "p-iteration": "^1.1.8",
    "passport": "0.6.0",
    "plugin": "^0.3.3",
    "promise.allsettled": "^1.0.4",
    "request": "2.88.2",
    "request-promise-native": "1.0.9",
    "throat": "6.0.1",
    "tv4": "1.3.0",
    "xlsx": "npm:@e965/xlsx@0.20.3"
  },
  "devDependencies": {
    "@babel/core": "^7.26.10",
    "@babel/plugin-transform-runtime": "^7.26.10",
    "@babel/preset-env": "^7.26.9",
    "@babel/register": "^7.25.9",
    "@babel/runtime": "^7.27.0",
    "angular": "1.8.2",
    "angular-animate": "1.8.2",
    "angular-aria": "1.8.2",
    "angular-cookies": "1.8.2",
    "angular-google-analytics": "1.1.8",
    "angular-messages": "1.8.2",
    "angular-mocks": "1.8.2",
    "angular-resource": "1.8.2",
    "angular-route": "1.8.2",
    "angular-sanitize": "1.8.2",
    "angular-touch": "1.8.2",
    "angular-ui-bootstrap": "2.5.6",
    "angular-ui-router": "0.4.3",
    "babel-jest": "26.6.3",
    "babelify": "10.0.0",
    "browser-sync": "3.0.4",
    "browserify": "17.0.1",
    "browserify-ngannotate": "2.0.0",
    "browserify-shim": "3.8.16",
    "chai": "4.3.4",
    "chai-as-promised": "7.1.1",
    "cypress": "14.3.0",
    "debug": "4.3.1",
    "del": "6.0.0",
    "eslint": "^7.25.0",
    "eslint-config-airbnb-base": "14.2.1",
    "eslint-config-prettier": "8.3.0",
    "eslint-plugin-import": "2.22.1",
    "eslint-plugin-prettier": "3.4.0",
    "fancy-log": "2.0.0",
    "file-saver": "1.3.3",
    "font-awesome": "4.7.0",
    "gulp": "^3.9.1",
    "gulp-angular-templatecache": "3.0.0",
    "gulp-conventional-changelog": "2.0.35",
    "gulp-header": "2.0.9",
    "gulp-jscs": "4.1.0",
    "gulp-jshint": "2.1.0",
    "gulp-load-plugins": "2.0.6",
    "gulp-minify-html": "1.0.6",
    "gulp-mocha": "7.0.2",
    "gulp-nodemon": "2.5.0",
    "gulp-protractor": "4.1.1",
    "gulp-rename": "2.0.0",
    "gulp-sass": "5.1.0",
    "gulp-sourcemaps": "3.0.0",
    "gulp-trailing-comma": "0.0.2",
    "gulp-uglify-es": "2.0.0",
    "jest": "26.6.3",
    "lokijs": "1.5.8",
    "mongodb-memory-server": "8.15.1",
    "ng-array-filter": "0.0.4",
    "ng-file-upload": "12.2.13",
    "ng-group-by": "0.0.3",
    "node-sass": "9.0.0",
    "nyc": "^15.1.0",
    "prettier": "2.2.1",
    "protractor": "5.4.4",
    "protractor-accessibility-plugin": "0.3.0",
    "protractor-console": "3.0.0",
    "puppeteer": "2.1.1",
    "require-dir": "1.2.0",
    "run-sequence": "2.2.1",
    "saslprep": "1.0.3",
    "sass": "1.70.0",
    "sass-flex-mixin": "1.0.3",
    "sinon": "10.0.0",
    "supertest": "6.1.3",
    "textangular": "1.5.16",
    "vinyl-buffer": "1.0.1",
    "vinyl-source-stream": "2.0.0",
    "watchify": "3.11.1",
    "wd": "1.14.0",
    "wd-bridge": "0.0.2",
    "yargs": "16.2.0"
  },
  "jestSonar": {
    "reportPath": "coverage",
    "reportFile": "sonar-reporter.xml"
  }
}
